import Form from "shared/components/inputs/form/Form";
import ModalActions from "shared/components/feedback/modals/ModalActions";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import { sendNotification } from "shared/components/feedback/notification/notification";
import useAccessGroupMembersApi from "features/admin/access-groups/single/useAccessGroupMembers";

const AccessGroupMemberDeleteModal = ({
    accessGroupId,
    accessGroupName,
    accessGroupMemberIdToDelete,
    onClose,
}) => {
    const { useAccessGroupMembers, deleteAccessGroupMember } =
        useAccessGroupMembersApi();
    const memberElement = useAccessGroupMembers(accessGroupId);

    if (memberElement.isLoading) {
        return <div>Loading...</div>;
    }

    if (memberElement.error) {
        return <div>Error</div>;
    }

    const modifier = deleteAccessGroupMember;

    const currentMemberData = memberElement.data.find(
        (member) => member.memberId === accessGroupMemberIdToDelete
    );
    if (!currentMemberData) {
        return <div>Could not find member</div>;
    }

    const onSubmit = async () => {
        const memberData = {
            memberId: accessGroupMemberIdToDelete,
            type: currentMemberData.type,
        };

        const allData = { groupId: accessGroupId, body: memberData };

        await modifier.mutateAsync(allData);
        onClose();
        sendNotification(
            <>
                <b>{currentMemberData.memberName}</b> has been removed from{" "}
                <b>{accessGroupName}</b>.
            </>
        );
    };

    return (
        <Form onSubmit={onSubmit}>
            <VStack spacing="Three">
                <VStack>
                    <Text variant="Body_1_1" color="Gray_2">
                        Are you sure you&apos;d like to remove{" "}
                        <span style={{ fontWeight: "700" }}>
                            {currentMemberData.memberName}
                        </span>{" "}
                        from this Access Group:{" "}
                        <span style={{ fontWeight: "700" }}>
                            {accessGroupName}
                        </span>?
                    </Text>
                </VStack>
                <ModalActions
                    primaryAction={{
                        type: "submit",
                        label: "Yes, Remove",
                    }}
                    secondaryAction={{
                        type: "button",
                        label: "Cancel",
                        onClick: onClose,
                    }}
                    as="fieldset"
                    disabled={modifier.isLoading}
                />
            </VStack>
        </Form>
    );
};

AccessGroupMemberDeleteModal.propTypes = {
    accessGroupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    accessGroupName: PropTypes.string.isRequired,
    accessGroupMemberIdToDelete: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired
};

export default AccessGroupMemberDeleteModal;
